import { TableV3ColDefs } from 'common/table';
import { SearchableCandidateBatchSortableFields } from 'generated-graphql/types';
import { SourcingInternalAnalysisSelectionTableData } from 'modules/sourcing-internal/tables/types';

export const sourcingInternalAnalysisSelectionColumns: TableV3ColDefs<
  SourcingInternalAnalysisSelectionTableData,
  SearchableCandidateBatchSortableFields
> = [
  {
    field: 'jobTitle',
    headerName: 'Job title',
    flex: 1
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1
  },
  {
    field: 'updatedAt',
    headerName: 'Updated at',
    flex: 1,
    sortField: SearchableCandidateBatchSortableFields.UpdatedAt
  },
  {
    field: 'candidatesCount',
    headerName: 'Applied',
    flex: 1,
    sortField: SearchableCandidateBatchSortableFields.CandidatesCount
  },
  {
    field: 'atsJobId',
    headerName: 'Job ID',
    flex: 1,
    sortField: SearchableCandidateBatchSortableFields.AtsJobId
  },
  {
    field: 'fullName',
    headerName: 'Owner',
    flex: 1
  }
];
